/**
 * Normalize To/Cc/Bcc from API payloads (string[], comma/semicolon string, or nested).
 */
export function emailsFromPayload(value: unknown): string[] {
  if (value == null || value === "") return [];
  if (Array.isArray(value)) {
    return value
      .map((v) => (typeof v === "string" ? v : String(v)))
      .flatMap((s) => s.split(/[,;]/))
      .map((s) => s.trim())
      .filter(Boolean);
  }
  if (typeof value === "string") {
    return value
      .split(/[,;]/)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}
